import { render } from "./tablePagination.vue?vue&type=template&id=a3ff53d6"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"

import "./tablePagination.vue?vue&type=style&index=0&id=a3ff53d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__